(function () {
    'use strict';

    function directPartnerConnectionEditorController($rootScope, $scope, $timeout, $window,
        directPartnerConnectionsDataService, notifyService, searchConfiguration, sessionData, milestones, milestoneModalService) {

        var vm = this;
        vm.config = searchConfiguration;
        vm.sessionData = sessionData;
        vm.results = [];
        vm.showResults = false;
        vm.attributes = {};
        vm.searchConfiguration = {};
        vm.project = {};
        vm.requestedPartners = [];
        vm.pageIndex = 0;
        vm.pageSize = searchConfiguration.DefaultPageSize || 5;
        vm.totalItems = 0;
        vm.searchControlId = 'directPartnerConnectionSearch';
        vm.isPortalAdmin = vm.sessionData.EntityType === 'Portal Administrator';

        vm.isSearchHidden = false;
        vm.toggleSearchVisibility = function() {
            vm.isSearchHidden = !vm.isSearchHidden;
        }

        vm.referralData = {
            platformId: vm.sessionData.Entity.PlatformId,
            siteConfigurationId: vm.sessionData.Entity.SiteConfigurationId,
            referrerEntityId: vm.sessionData.EntityId,
            objectType: '',
            objectId: '',
            objectReferralPath: '',
            objectReferralMessage: 'You were invited to the platform'
        }

        milestoneModalService.getMilestonesAndTemplates(milestones).then(function (milestonesAndTemplates) {
            if (milestonesAndTemplates.length > 0) {
                milestoneModalService.openModal(milestonesAndTemplates);
            }
        });

        vm.togglePartnerConnection = function (entity) {
            if (entity.isSelected) {
                var index = vm.requestedPartners.indexOf(entity);
                vm.requestedPartners.splice(index, 1);
            }
            else {
                vm.requestedPartners.push(entity);
            }

            entity.isSelected = !entity.isSelected;
        }

        vm.createDirectPartnerConnectionRequests = function () {

            var createRequests = [];

            for (var i = 0; i < vm.requestedPartners.length; i++) {
                createRequests.push({
                    "EntityId": vm.sessionData.EntityId,
                    "PartnerId": vm.requestedPartners[i].Id
                });
            }

            directPartnerConnectionsDataService.createBatch(createRequests).then(function () {
                notifyService.notify('You successfully created request(s) to connect with partners and are being redirected to your dashboard.');
                $timeout(function () {
                    $window.location = '/dashboard';
                }, 3000);
            });

        }

        vm.createDirectPartnerRequest =  function(partner) {
            directPartnerConnectionsDataService.createBatch([
                {
                    "EntityId": vm.sessionData.EntityId,
                    "PartnerId": partner.Id
                }
            ]).then(function(data) {
                notifyService.notify(
                    'The email address you entered is already on your platform and we have created a request to connect with this partner.');
            });
        }

        vm.togglePartnerIntroduction = function (partner, partnerConnections) {
            var partnerIds = partnerConnections.map(function (item) {
                return item.Id;
            });
            var indexOfPartnerToAdd = partnerIds.indexOf(partner.Id);
            if (indexOfPartnerToAdd !== -1) {
                partnerIds.splice(indexOfPartnerToAdd, 1);
                partner.isSelected = false;
            } else {
                partnerConnections.push({
                    EntityId: partner.Id,
                    Status: 'Requested',
                    LastActivityDate: new Date(),
                    Partner: partner
                });
                partner.isSelected = true;
            }
        }

        vm.actions = {
            doAction: {
                label: "Request Introduction",
                call: vm.togglePartnerConnection,
                cssClass: "md-primary"
            }
        }

        vm.changePageIndex = function () {
            $rootScope.$emit('pageIndexChanged', { searchControlId: vm.searchControlId, pageIndex: vm.pageIndex });
        }

        vm.changePageSize = function () {
            vm.pageIndex = 0;
            $rootScope.$emit('pageSizeChanged', { searchControlId: vm.searchControlId, pageSize: vm.pageSize, pageIndex: vm.pageIndex });
        }

        $rootScope.$on('searchResultsChanged', function (event, args) {
            if (args.searchControlId === vm.searchControlId) {
                vm.results = args.results;
                vm.totalItems = args.totalItems;
                vm.results = vm.results.map(function (item) {
                    item.isSelected = vm.requestedPartners.map(function(partner) { return partner.Id;})
                        .indexOf(item.Id) !== -1;
                    return item;
                });
            }
        });
    }

    directPartnerConnectionEditorController.$inject = ['$rootScope','$scope', '$timeout', '$window',
        'directPartnerConnectionsDataService', 'notifyService', 'searchConfiguration', 'sessionData', 'milestones', 'milestoneModalService'];

    angular.module('ecap.dashboards').controller('directPartnerConnectionEditorController', directPartnerConnectionEditorController);
})();
